export default __webpack_public_path__ + "static/media/lds-logo_lv.38c899131fa1e998.svg";